import { Alert, CircularProgress, FormControl, InputLabel, Modal, Snackbar, Box, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import useStateRef from "react-usestateref";
import { defaultValues, schema } from "./ValidacoesOcupante";
import { useDispatch, useSelector } from "react-redux";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import servOcupante from "../../../services/login/servOcupante";
import servOcupanteDocs from "../../../services/login/servOcupanteDocs";

import { parse } from "date-fns";
import styles from "./Cadastro.module.css";
import { logout } from "../../../state/slices/userSlice";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { Geral } from "./Abas/Geral";
import { Documentos } from "./Abas/Documentos";
import { Localizacao } from "./Abas/Localizacao";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward } from "@fortawesome/free-solid-svg-icons";
import { validarCnpj, validarCpf } from "../../../infra/utils/ValidacaoCpf";

import servParam from "../../../services/login/servParam";


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({ setOpenPopup, recordForEdit, addOrEdit, pesquisar }) => {
    const methods = useForm({ mode: "onBlur", defaultValues: defaultValues, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);

    const [podeSalvar, setPodeSalvar] = useState(true);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [cnpjInvalido, setCnpjInvalido] = useState(false);
    const [cpfInvalido, setCpfInvalido] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [disableUpload, setDisableUpload] = useState(false);
    const [disableCampos, setDisableCampos] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [fecharAoSalvar, setFecharAoSalvar, fecharAoSalvarRef] = useStateRef(true);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
    const [loadOcupantes, setLoadOcupantes] = useState(null);
    const [disableAba, setDisableAba] = useState(null);

    const [required, setRequired] = useState(false);
    const [situacao, setSituacao] = useState(0);
    const [desabilitaHomologacao, setDesabilitaHomologacao] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    const handleCloseWindow = () => {
        pesquisar();
        setOpenPopup(false);
    }

    const proximaAba = async () => {
        const situacaoNaoEditaveis = [1, 3, 4, 5, 6, 7];

        if (methods.getValues("inscricao") && !validarCnpj(methods.getValues("inscricao"))) {
            setCnpjInvalido(true);
            setErrorMessage("CNPJ inválido.");
            setOpen(true);
            return;
        }

        if (methods.getValues("cpfRepresentante") && !validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        if (disableAba) return;

        if (situacaoNaoEditaveis.includes(methods.getValues("situacao"))) {
            setDesabilitaHomologacao(true);
            if (tabIndex === 2) {
                return setTabIndex(0)
            } else {
                setTabIndex(tabIndex + 1);
            }

            return;
        }

        let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

        if (houveAlteracaoCampos) {
            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }
        }

        if (methods.getValues("Id") == 0 || methods.getValues("Id") == null || methods.getValues("Id") == undefined) {
            if (tabIndex === 1) {
                setFecharAoSalvar(false)
                await handleCadastroOcupante();
                setFecharAoSalvar(true);

                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }
        } else {
            if (tabIndex === 1) {
                recuperarDocumentosIniciais();
            }
        }

        if (tabIndex === 2) {
            return setTabIndex(0)
        }

        setTabIndex(tabIndex + 1);
    }

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccess(false);
        }

        setOpenSuccess(false);
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }

    const recuperarDocumentosIniciais = async () => {
        try {
            setIsLoading(true);

            const idOcupante = recordForEdit ? recordForEdit?.id || recordForEdit?.Id : methods.getValues("Id");

            const [docsObrigatorios, docsVinculados] = await Promise.all([
                servParam.RecuperarDocumentosObrigatorios(11),
                servOcupanteDocs.listar(idOcupante)
            ]);

            const docsAtualizados = mapearCamposDaEdicaoDocs(docsObrigatorios.Content, docsVinculados.Content);

            setIsLoading(false);

            return docsAtualizados;
        } catch (err) {
            setIsLoading(false);

            if (err?.response?.status === 401) {
                setErrorMessage("Token expirado, redirecionando...");
                setOpen(true);
                return setTimeout(() => {
                    dispatch(logout());
                    navigate("/");
                }, [2000]);
            }

            setErrorMessage(err?.response?.data?.Message);
            setOpen(true);
        }
    }

    useEffect(() => {
        const situacoesBloqueadas = [1, 3, 4, 5, 6, 7];

        if (recordForEdit !== null) {

            const recuperarDados = async () => {
                try {
                    setIsLoading(true);

                    let data = await servOcupante.RecuperarParaEditar(recordForEdit?.id || recordForEdit?.Id);
                    mapearCamposDaEdicao(data.Content);
                    setSituacao(data.Content.Situacao)

                    setIsLoading(false);

                } catch (err) {
                    setIsLoading(false);

                    if (err?.response?.status === 401) {
                        setErrorMessage("Token expirado, redirecionando...");
                        setOpen(true);
                        return setTimeout(() => {
                            dispatch(logout());
                            navigate("/");
                        }, [2000]);
                    }

                    setErrorMessage(err?.response?.data?.Message);
                    setOpen(true);
                }
            }

            recuperarDados();
            recuperarDocumentosIniciais();

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao)) {
                setPodeSalvar(false);
                setDisableUpload(true);
                setDisableCampos(true);
            }
        }
    }, [recordForEdit]);

    const handleClickOpenDialog = async (event, reason) => {
        try {
            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            const docsAtualizados = await recuperarDocumentosIniciais();

            const docsObrigatoriosPendentes = (docsAtualizados ?? documentosObrigatorios).filter(
                doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
            );

            if (docsObrigatoriosPendentes.length > 0) {
                const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
                setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
                setOpen(true);
                return;
            }

            if (reason === 'clickaway') {
                setOpenDialog(true);
            }

            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const mapearCamposDaEdicaoDocs = (docsObrigatorios, docsVinculados) => {
        const docsAtualizados = docsObrigatorios.map((doc) => {
            const documentoVinculado = docsVinculados?.find(
                (docVinculado) =>
                    doc.Id == docVinculado.CodigoConfiguracaoDoc &&
                    doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
            );

            if (documentoVinculado) {
                return {
                    ...doc,
                    CodigoOcupanteDoc: documentoVinculado.Id,
                    CodigoDocumento: documentoVinculado.CodigoDocs,
                    NomeArquivo: documentoVinculado.NomeArquivo,
                    Aprovado: documentoVinculado.Aprovado
                };
            }

            return doc;
        });

        setDocumentosObrigatorios(docsAtualizados);

        return docsAtualizados;
    };

    const mapearCamposDaEdicao = (data) => {
        delete data.Cidades.UF;

        methods.setValue("Id", data.Id);
        methods.setValue("codigo", data.Codigo);
        methods.setValue("nome", data.Nome);
        methods.setValue("inscricao", data.Inscricao);
        methods.setValue("uf", data.Uf);
        methods.setValue("endereco", data.Endereco);
        methods.setValue("numero", data.Numero);
        methods.setValue("bairro", data.Bairro);
        methods.setValue("cep", data.Cep);
        methods.setValue("nomeRepresentante", data.NomeRepresentante);
        methods.setValue("cpfRepresentante", data.CpfRepresentante);
        methods.setValue("numeroTermoAutorizacao", data.NumeroTermoAutorizacao);
        methods.setValue("dataAto", parse(data.DataAto, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("processoAnatel", data.ProcessoAnatel);
        methods.setValue("numeroContrato", data.NumeroContrato);
        methods.setValue("situacao", data.Situacao);

        if (data.CodigoCidade) {
            methods.setValue("codigoCidade", {
                value: data.Cidades.Id,
                label: data.Cidades.Nome
            });

            methods.setValue("Cidades", data.Cidades);
        }
    };

    const handleCadastroOcupante = methods.handleSubmit(async (data) => {
        if (!validarCnpj(methods.getValues("inscricao"))) {
            setCnpjInvalido(true);
            setErrorMessage("CNPJ inválido.");
            setOpen(true);
            return;
        }

        if (!validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        if (Object.keys(methods.formState.errors).length > 0) {
            var errors = methods.formState.errors;

            if (errors.nome || errors.inscricao) {
                setTabIndex(0);
                return;
            }

            setTabIndex(1);
            return
        }

        try {
            data.inscricao = data.inscricao.replace(/[^A-Za-z0-9]/g, "");
            data.cep = data.cep.replace(/\D/g, "");
            data.cpfRepresentante = data.cpfRepresentante.replace(/\D/g, "");

            const ocupante = {
                Id: data.Id,
                nome: data.nome,
                inscricao: data.inscricao,
                codigoCidade: data.codigoCidade?.value,
                Cidades: data.codigoCidade?.label,
                uf: typeof data.uf == 'object' ? data.uf?.value : data.uf,
                endereco: data.endereco,
                numero: data.numero,
                bairro: data.bairro,
                cep: data.cep,
                nomeRepresentante: data.nomeRepresentante,
                cpfRepresentante: data.cpfRepresentante,
                numeroTermoAutorizacao: data.numeroTermoAutorizacao,
                dataAto: data.dataAto,
                processoAnatel: data.processoAnatel,
                numeroContrato: data.numeroContrato,
                situacao: data.situacao,

            }

            setIsLoading(true);

            let codigoOcupante = await adicionarOuEditar(ocupante);
            methods.setValue("Id", codigoOcupante);
            methods.reset({}, { keepValues: true });
            recuperarDocumentosIniciais();

            setIsLoading(false);

            setOpenSuccess(true);
            setSuccessMessage("Ocupante salvo com sucesso.");

            if (fecharAoSalvarRef.current) {
                setOpenPopup(false);
            }
            pesquisar();

        } catch (err) {
            setIsLoading(false);
            setOpen(true);
            pesquisar();
            setErrorMessage(err?.response?.data?.Message || "Ocorreu um erro ao salvar o ocupante.");
            return;
        }
    });

    const adicionarOuEditar = async (ocupante) => {
        let id;
        ocupante.cadastradoPorAnalista = false;
        ocupante.codigoResponsavelTecnico = user.codigoUsuario;

        if (!ocupante.Id) {
            const response = await servOcupante.inserir(
                ocupante.codigoResponsavelTecnico || 0,
                ocupante.nome || "",
                ocupante.inscricao || "",
                ocupante.codigoCidade || 0,
                ocupante.Cidades || "",
                ocupante.uf || "",
                ocupante.endereco || "",
                Number(ocupante.numero) || 0,
                ocupante.bairro || "",
                ocupante.cep || "",
                ocupante.nomeRepresentante || "",
                ocupante.cpfRepresentante || "",
                Number(ocupante.numeroTermoAutorizacao) || 0,
                ocupante.dataAto || null,
                ocupante.processoAnatel || "",
                ocupante.numeroContrato || "",
                ocupante.situacao || 0,
                ocupante.dataEnvioHomologacao,
                ocupante.dataPrazoAnalise,
                ocupante.cadastradoPorAnalista
            );

            id = response.Content.Id;
        } else {
            const response = await servOcupante.editar(
                ocupante.Id,
                ocupante.codigoResponsavelTecnico || 0,
                ocupante.codigoUsoMutuo || 0,
                ocupante.descricaoUsoMutuo || "",
                ocupante.nome || "",
                ocupante.inscricao || "",
                ocupante.codigoCidade || 0,
                ocupante.Cidades || "",
                ocupante.uf || "",
                ocupante.endereco || "",
                Number(ocupante.numero) || 0,
                ocupante.bairro || "",
                ocupante.cep || "",
                ocupante.nomeRepresentante || "",
                ocupante.cpfRepresentante || "",
                Number(ocupante.numeroTermoAutorizacao) || 0,
                ocupante.dataAto || null,
                ocupante.processoAnatel || "",
                ocupante.numeroContrato || "",
                ocupante.situacao || 0,
                ocupante.dataCadastro || new Date(),
                ocupante.dataEnvioHomologacao || null,
                ocupante.dataPrazoAnalise || null
            )

            id = response.Content.Id;
        }

        return id;
    }

    const handleTabChange = async (event, newValue) => {
        const situacaoNaoEditaveis = [1, 3, 4, 5, 6, 7];

        if (methods.getValues("inscricao") && !validarCnpj(methods.getValues("inscricao"))) {
            setCnpjInvalido(true);
            setErrorMessage("CNPJ inválido.");
            setOpen(true);
            return;
        }

        if (methods.getValues("cpfRepresentante") && !validarCpf(methods.getValues("cpfRepresentante"))) {
            setCpfInvalido(true);
            setErrorMessage("CPF inválido.");
            setOpen(true);
            return;
        }

        if (disableAba) return;

        if (situacaoNaoEditaveis.includes(methods.getValues("situacao"))) {
            setTabIndex(newValue);
            return;
        }

        if ((methods.getValues("Id") == 0 || methods.getValues("Id") == null || methods.getValues("Id") == undefined)) {
            if (newValue === 2) {
                setFecharAoSalvar(false);
                await handleCadastroOcupante();
                setFecharAoSalvar(true);
            }

            if (Object.keys(methods.formState.errors).length > 0) {
                var errors = methods.formState.errors;

                if (errors.nome || errors.inscricao) {
                    setTabIndex(0);
                    return;
                }

                setTabIndex(1);
                return
            }

            setTabIndex(newValue);
        } else {
            let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

            if (houveAlteracaoCampos && newValue === 2) {
                setFecharAoSalvar(false)
                await handleCadastroOcupante();
                setFecharAoSalvar(true);

                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }

            recuperarDocumentosIniciais();

            setTabIndex(newValue);
        }
    }

    const solicitarHomologacao = async () => {
        try {
            setIsLoading(true);

            await servOcupante.SolicitarHomologacao(methods.getValues("Id"));

            setOpenSuccess(true);
            setSuccessMessage("Solicitação de homologação enviada com sucesso.");
            setIsLoading(false);

            setOpenDialog(false);

            setTimeout(() => {
                setOpenPopup(false);
                pesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setErrorMessage(err?.response?.data?.Message);
            return setOpen(true);
        }
    }

    const situacaoRegistro = Number(
        recordForEdit?.Situacao ?? recordForEdit?.row?.Situacao ?? 0
    );

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <FormProvider {...methods}>
                <form onSubmit={handleCadastroOcupante} className={styles.cadastro_ocupante}>
                    <div className={styles.class100E}>
                        <div className={styles.tabsEHeader}>
                            <Tabs value={tabIndex} sx={{ width: "95%" }} onChange={handleTabChange} aria-label="abas cadastro de ocupantes">
                                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                                <Tab sx={{ color: disableAba ? "#303030" : "whitesmoke" }} label="Localização" {...a11yProps(1)} />
                                <Tab sx={{ color: disableAba ? "#303030" : "whitesmoke" }} label="Documentos" {...a11yProps(2)} />
                            </Tabs>
                        </div>
                        <TabPanel value={tabIndex} index={0}>
                            <Geral
                                disableCampos={disableCampos}
                                setOpen={setOpen}
                                cnpjInvalido={cnpjInvalido}
                                setCnpjInvalido={setCnpjInvalido}
                                cpfInvalido={cpfInvalido}
                                setDisableAba={setDisableAba}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                setPodeSalvar={setPodeSalvar}
                                recordForEdit={recordForEdit}
                                situacao={situacao}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Localizacao
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                setErrorMessage={setErrorMessage}
                                camposDesabilitados={disableCampos}
                                recordForEdit={recordForEdit}
                                onKeyDown={methods.handleKeyDown}
                                podeSalvar={podeSalvar}
                                loadOcupantes={loadOcupantes}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <Documentos
                                codigoOcupante={methods.getValues('Id')}
                                documentos={documentosObrigatorios}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                setErrorMessage={setErrorMessage}
                                situacaoSolic={situacaoRegistro}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles.cadastro_ocupante_botoes}>
                        <BlueHoverButton onClick={proximaAba} disabled={!podeSalvar}>
                            {tabIndex == 0 ? (
                                <div>Informar localização</div>
                            ) : tabIndex == 1 ? (
                                <div>Informar documentos</div>
                            ) : (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <FontAwesomeIcon icon={faBackward} style={{ paddingRight: "10px", fontSize: "16px" }} />
                                    <div>Revisar dados gerais</div>
                                </div>
                            )}
                        </BlueHoverButton>
                        {tabIndex == 2 && (
                            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar || desabilitaHomologacao}>
                                Solicitar homologação
                            </BlueHoverButton>
                        )}
                        {(tabIndex !== 0 && <BlueHoverButton type="submit" id="salvarOcupante" name="salvarOcupante" disabled={!podeSalvar}>
                            Salvar
                        </BlueHoverButton>)}
                        <BlueHoverButton onClick={handleCloseWindow} >
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>
            <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                    {successMessage}
                </Alert>
            </Snackbar>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '600px',
                        maxWidth: '90vw',
                        padding: '10px',
                        borderRadius: '8px',
                        backgroundColor: "#232323",
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
                    {"Solicitar homologação"}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
                        Você deseja enviar o ocupante para homologação?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: "#232323" }}>
                    <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    <BlueHoverButton autoFocus onClick={solicitarHomologacao}>
                        Continuar
                    </BlueHoverButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export { Cadastro }
